import { api, badge, formatter } from './util';

/**
 * Plugin for saving Note to Procedure.
 */
(function ($) {
	let createApiRequest = function (btn) {
		let form = $(btn).parents('form');
		let url = form.attr('action');
		let data = {
			note: form.find('[name=note]').val().trim(),
			type: form.find('[name=type]').val().trim(),
		};

		badge.show(form.find('.badge'), 'icon-spinner', 'spinner-text', 5000);
		return api.put(url, data).done(function (response) {
			let dateTime = response.procedureNote.noteEditedTime;
			let user = response.procedureNote.noteEditedBy;
			form.find('.name').text(user.name);
			form.find('.time').text(formatter.formatDateTime(dateTime));
			badge.show(form.find('.badge'), 'icon-saved', 'saved-text', 5000);
		});
	};

	$('.procedure-note-form').find('[type=submit]').apiButton(createApiRequest);
})(jQuery);
